module.exports = __webpack_public_path__ + "fonts/Muli-Light.c5c7e6e8.eot";